import React, { ReactElement } from 'react';
import { withRouter } from 'react-router-dom';
import AccidentCard from '../AccidentCard/AccidentCard';
import CovidCaseCard from '../CovidCaseCard/CovidCaseCard';
import MaternityCard from '../MaternityCard/MaternityCard';
import OtherTreatmentDetailCard from '../OtherTreatmentDetailCard/OtherTreatmentDetailCard';
import PastHistoryCard from '../PastHistoryCard/PastHistoryCard';
import TreatmentDetailCard from '../TreatmentDetailCard/TreatmentDetailCard';

const TreatmentDetail = ({ isLoading, form }: any): ReactElement => {

  return <React.Fragment>
    <TreatmentDetailCard isLoading={isLoading} form={form} />
    <CovidCaseCard isLoading={isLoading} form={form} />
    <PastHistoryCard isLoading={isLoading} form={form} />
    <AccidentCard isLoading={isLoading} form={form} />
    <MaternityCard isLoading={isLoading} form={form} />
    <OtherTreatmentDetailCard isLoading={isLoading} form={form} />
  </React.Fragment>;
};

export default withRouter(TreatmentDetail);
